module.exports = __webpack_public_path__ + "img/hero-mobile.fcbf21cc.webp";